// src/StaticHome.js
import React from 'react';

// Importing images
import iconBrandDev from '../assets/img/06.png';
import iconSoundDesign from '../assets/img/001.png';
import iconMotionGraphics from '../assets/img/3.png';
import iconVFX from '../assets/img/04.png';
import checkIcon from '../assets/img/check-icon.png';
import costIcon from '../assets/img/cost.png';
import impactIcon from '../assets/img/impact.png';

function StaticHome() {
  return (
    <>
      <section>
        
        <div className="container my-5">
      <div className="gradient-border text-center">
      <h2 className="text-center mb-4" style={{ color: '#038ff7' }}>What we do</h2>
      <p
  className="text-secondary mb-5 mx-auto"
  style={{ maxWidth: '720px' }}
>
  We produce high-end commercials, branded content, visual storytelling, and post-production, from concept to final delivery.<br />
  Our services include:
</p>

        <div className="row">
      <div className="col-md-3 service-icon">
        <img src={iconBrandDev} alt="Brand development" className="icon-img mb-3" />
        <p className="service-title">Brand development</p>
      </div>
      <div className="col-md-3 service-icon">
        <img src={iconSoundDesign} alt="Editing and sound design" className="icon-img mb-3" />
        <p className="service-title">Editing and sound design</p>
      </div>
      <div className="col-md-3 service-icon">
        <img src={iconMotionGraphics} alt="Motion graphics & animation" className="icon-img mb-3" />
        <p className="service-title">Motion graphics & animation</p>
      </div>
      <div className="col-md-3 service-icon">
        <img src={iconVFX} alt="Color grading & VFX" className="icon-img mb-3" />
        <p className="service-title">Color grading & VFX</p>
      </div>
    </div>
  </div>
</div>
      </section>

      <section className="why-work-us">
        <div className="container">
          <h2 className="mb-5">Why should you <br />work with us?</h2>
          <a href="#" className="start-now">Start now!</a>

          <div className="cards">
            <div className="card">
              <div className="cardi-header">
                <h2 className="card-title">Expertise and specialization</h2>
                <div className="icon">
                  <img src={checkIcon} alt="Expertise Icon" />
                </div>
              </div>
              <p>
                Our team of experienced professionals covers all areas of creative process, from scriptwriting, filming to post-production. This results in precise and creative content with captivating stories that engage your audience.
              </p>
            </div>

            <div className="card">
              <div className="cardi-header">
                <h2 className="card-title">Time and cost efficiency</h2>
                <div className="icon">
                  <img src={costIcon} alt="Efficiency Icon" />
                </div>
              </div>
              <p>
                We handle the entire creative process and optimize it to meet tight deadlines without compromising quality. Thanks to state-of-the-art equipment and technologies, you save on investments in expensive tools and training.
              </p>
            </div>

            <div className="card">
              <div className="cardi-header">
                <h2 className="card-title">Impact</h2>
                <div className="icon">
                  <img src={impactIcon} alt="Impact Icon" />
                </div>
              </div>
              <p>
                Our creative storytelling techniques and refined visual representations are designed to captivate your target audience, encourage stronger engagement, and drive the growth of your business.
              </p>
            </div>

            <div className="footer-text">
              Working with us means investing in top-quality productions that elevate your brand and communicate your message effectively.
            </div>
          </div>
        </div>
      </section>

      <section className="trusted-by">
        <div className="container">
          <h2 className="mb-2">Trusted by</h2>
          <div className="trusted-background">
            {/* You can add logos or content here */}
          </div>
        </div>
      </section>
    </>
  );
}

export default StaticHome;
